import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  SidebarLeft,
  UserTable,
  CreateNotification,
  NotificationList
} from 'components';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Permissions from 'permissions';

@connect(state => ({}), Actions)
class NotificationsContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          filters: {},
          selected_user_ids: []
        }
    }

    render() {
      return (
      	<Container title="Notifications">
          <SidebarLeft title='Create Notification'>
            {!this.props.hasPermission(Permissions.CREATE_NOTIFICATIONS)? (
              <Alert bsStyle='warning'>
                <h3>Sorry!</h3>
                <p>You do not have permission to create notifications.</p>
              </Alert>
            ) : (
              <div>
                <CreateNotification total={this.state.total} userFilters={this.state.filters} onCreate={e => this.refs.notificationList.refresh()} />
                <hr />
                <NotificationList ref='notificationList' />
              </div>
            )}
          </SidebarLeft>
          <UserTable ref='userTable' onChangeFilters={filters => this.setState({ filters })} onUpdate={state => this.setState({ total: state.total })}/>
        </Container>
      );
    }
}

export default NotificationsContainer;



// WEBPACK FOOTER //
// ./src/browser/components/notifications/notifications-container.js